export enum UploaderType {
    Document,
    Image,
}
